import { render, staticRenderFns } from "./FileFilledIcon.vue?vue&type=template&id=20af6b0e&scoped=true&"
import script from "./FileFilledIcon.vue?vue&type=script&lang=js&"
export * from "./FileFilledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af6b0e",
  null
  
)

export default component.exports